import { render, staticRenderFns } from "./TaxiList.vue?vue&type=template&id=872823a2&scoped=true&"
import script from "./TaxiList.vue?vue&type=script&lang=js&"
export * from "./TaxiList.vue?vue&type=script&lang=js&"
import style0 from "./TaxiList.vue?vue&type=style&index=0&id=872823a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872823a2",
  null
  
)

export default component.exports